export const LOADING_CAMPAIGN = "LOADING_CAMPAIGN";
export const GET_CAMPAIGN = "GET_CAMPAIGN";
export const GET_CAMPAIGN_ID = "GET_CAMPAIGN_ID";
export const POST_CAMPAIGN_ID = "POST_CAMPAIGN_ID";
export const DELETE_CAMPAIGN = "DELETE_CAMPAIGN";
export const UPDATE_CAMPAIGN = "UPDATE_CAMPAIGN";